import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { DateTime } from 'luxon';

export const getAge = (dateOfBirth: DateTime) =>
    dateOfBirth && Math.floor(DateTime.utc().diff(dateOfBirth, 'years')?.years);

export const utcNow = () => DateTime.now().toUTC();
export const isoToUtc = (isoDateString: string) => DateTime.fromISO(isoDateString, { zone: 'utc' });

export const getFirstDateOfCurrentMonth = () => DateTime.utc(DateTime.utc().year, DateTime.utc().month, 1);

export const getDateOfCurrentMonth = (day: number) => DateTime.utc(DateTime.utc().year, DateTime.utc().month, day);

export const getLastOfCurrentMonth = () => DateTime.utc(DateTime.utc().year, DateTime.utc().month, 1).endOf('month');

export const toNgbDate = (dateTime: DateTime | null) =>
    dateTime?.isValid ? new NgbDate(dateTime.year, dateTime.month, dateTime.day) : null;
export const toNgbDateFromDate = (date: Date) => new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
export const toNgbDateFromString = (date: string | null) => (date ? toNgbDate(dateTimeFromISO(date)) : null);
export const fromNgbDate = (date: NgbDate) => date && DateTime.local(date.year, date.month, date.day, { zone: 'utc' });
export const toDateFromNgbDate = (date: NgbDate) => new Date(date.year, date.month - 1, date.day);

export const isTodayUtc = (dateTime: DateTime) => {
    const today = DateTime.utc();
    return dateTime.year === today.year && dateTime.month === today.month && dateTime.day === today.day;
};

export const isYesterdayUtc = (dateTime: DateTime) => {
    const yesterday = DateTime.utc().minus({ days: 1 });
    return dateTime.year === yesterday.year && dateTime.month === yesterday.month && dateTime.day === yesterday.day;
};

export const dateTimeFromISO = (dateTime: string | null) => dateTime && DateTime.fromISO(dateTime);

export const toDateISOString = (date: Date | null) => date.toLocaleDateString('sv-SE');
export const toDateISOStringFromDateTime = (date: DateTime | null) => date.toISODate();
